/** Cont file */
//public variables and secret keys
import moment from "moment-timezone";
let documentTitle = "Attorney Application";
let API_BASE = "https://devapi.uslegalservices.net/api/attorney_portal/";
let CLAIM_BASE = "https://devapi.uslegalservices.net/api/attorney_claims/v2/";
let AGEN_API ="https://devapi.uslegalservices.net/api/agent/"
let SHARP_SPRINT_API_BASE = "https://api.sharpspring.com/pubapi/v1";
let SECRET_KEY = "MO142kXCFMpvVucyzZ8399e439DSD8Jd6rZO";
let MS_BASE = "https://devms.uslegalservices.net/usl";
let BASE_S3 = "https://uslawstests3.s3.amazonaws.com";
let SELECTED_TRUE = "https://81omgd2sb0.execute-api.us-east-1.amazonaws.com/api/checkSelectedTrue";
let GENERATE_TOKEN = "https://81omgd2sb0.execute-api.us-east-1.amazonaws.com/api/generateToken";
let START_STATE_MACHINE = "https://81omgd2sb0.execute-api.us-east-1.amazonaws.com/api/startFeeScheduleStateMachine";
let IS_TEST = true;
const ED_KEY = "123jsdkaha45sd54asd5as4d654"; 
let HS_kEY="83e9e6fb8fc867b64930cbb8e145facd";

if (
  window.location.origin != "https://devattportal.uslegalservices.net" &&
  window.location.origin != "http://localhost:8080" && 
  window.location.origin != "http://localhost:8081"
) {
  API_BASE = "https://api.uslegalservices.net/api/attorney_portal/";
  CLAIM_BASE = "https://api.uslegalservices.net/api/attorney_claims/v2/";
  MS_BASE = "https://usl.uslegalservices.net/usl";
  AGEN_API ="https://api.uslegalservices.net/api/agent/";
  SELECTED_TRUE = "https://by2cb8mto2.execute-api.us-east-1.amazonaws.com/api/checkSelectedTrue";
  GENERATE_TOKEN = "https://by2cb8mto2.execute-api.us-east-1.amazonaws.com/api/generateToken";
  START_STATE_MACHINE = "https://by2cb8mto2.execute-api.us-east-1.amazonaws.com/api/startFeeScheduleStateMachine";
  IS_TEST = false;
  HS_kEY="f3c2738874829d6895be9e57f3c37103";
}

const setDateFormat = date => {
  if (date != null && date != "" && date != "0000-00-00 00:00:00") {
    return moment(date).format("MM/DD/YYYY");
  } else if (date == "0000-00-00 00:00:00") {
    return "";
  }
};
export default {
  setDateFormat,
  documentTitle,
  API_BASE,
  CLAIM_BASE,
  SHARP_SPRINT_API_BASE,
  SECRET_KEY,
  MS_BASE,
  BASE_S3,
  AGEN_API,
  SELECTED_TRUE,
  GENERATE_TOKEN,
  START_STATE_MACHINE,
  IS_TEST,
  ED_KEY,
  HS_kEY
};